import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

interface FrontStockAgeRecordState extends ListState<any>
{
}

class FrontStockAgeMutations extends ListMutations<FrontStockAgeRecordState>
{

}
class FrontStockAgeRecord extends ListModule<FrontStockAgeRecordState, any, any>
{
    state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<any>(),
    loading: false,
}
        actions = {
            async getAll(context: ActionContext<FrontStockAgeRecordState, any>
            , payload: any) {
            context.state.loading = true;
                let reponse = await Ajax.get('/api/services/app/FrontStockAgeRecord/GetRecordList', { params: payload.data });
                context.state.loading = false;
                let page = reponse.data.result as PageResult<any>;
                context.state.totalCount = page.totalCount;
                context.state.list = page.items;
                },
            };
                        mutations = {
                            setCurrentPage(state: FrontStockAgeRecordState, page: number) {
                        state.currentPage = page;
                        },
                            setPageSize(state: FrontStockAgeRecordState, pagesize: number) {
                        state.pageSize = pagesize;
                        }
                        }
                        }

const frontStockAgeRecord = new FrontStockAgeRecord();
export default frontStockAgeRecord;
